import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  ErrorHandler,
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { IMAGE_LOADER } from '@angular/common';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { transferStateInterceptor } from './interceptors/transfer-state.interceptor';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { APP_CONFIG } from './app.config.token';
import { environment } from '../environments/environment';
import { BN_API_CONFIG } from '@bossanova/ui-kit';

import { GlobalErrorHandler } from './common/global-error-handler';
import { youtubeImageLoader } from './common/youtube-image.loader';

import { createAbility } from '@bossanova/models';
import { PureAbility } from '@casl/ability';
import { AbilityService } from '@casl/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(appRoutes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        transferStateInterceptor,
        errorInterceptor,
      ]),
    ),
    {
      provide: APP_CONFIG,
      useValue: {
        apiUrl: environment.apiUrl,
      },
    },
    {
      provide: BN_API_CONFIG,
      useValue: {
        apiUrl: environment.apiUrl,
      },
    },
    {
      provide: IMAGE_LOADER,
      useValue: youtubeImageLoader,
    },
    { provide: PureAbility, useFactory: () => createAbility() },
    AbilityService,
  ],
};
